<span [innerHTML]="data" [attr.aria-label]="alt"></span>
